import { atom } from "recoil";
import { persistAtom } from "./persist";

export const AllstarOauthState = atom({
  key: "AllstarOauthState_v0.1",
  default: {
    expiry: 0,
    referrer: "",
    route: "",
    path: "",
    flow: "",
    errorMessage: "",
    successMessage: "",
    errorType: "",
    randomBlob: "",
  },
  effects_UNSTABLE: [persistAtom],
});
